import React, { createContext, useContext, useState, useEffect } from 'react';
import { loadRuntimeConfig, resolveApiRoot } from '../services/configService';

const ConfigContext = createContext(null);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const loadedConfig = await loadRuntimeConfig();
        setConfig(loadedConfig);
      } catch (err) {
        console.error('Error loading config:', err);
        setError(err);
        // Set fallback config
        setConfig({
          apiRoot: resolveApiRoot(process.env.API_ROOT || ''),
          homepageUrl: 'https://camelstep.com',
          version: 'build-time',
        });
      } finally {
        setIsLoading(false);
      }
    };

    loadConfig();
  }, []);

  const value = {
    config,
    isLoading,
    error,
  };

  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within ConfigProvider');
  }
  return context;
};
